module.exports = __webpack_public_path__ + "img/icon-rain.fdb25976.svg";